
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// import data from '../data/data.json' assert { type: "json" };
var $7e152637e430236b$exports = {};
$7e152637e430236b$exports = JSON.parse('{"filtersSelected":{"events":{"party":true,"festival":true,"workshop":true},"dances":{"salsa":true,"bachata":true,"kizomba":true,"tango":true,"reggaeton":true,"zumba":true,"rumba":true,"samba":true},"types":{"club":true,"school":true,"studio":true}},"filters":{"events":["party","festival","workshop"],"dances":["salsa","bachata","kizomba","tango","reggaeton","zumba","samba"],"types":["club","school","studio"]},"danceEvents":[{"id":986247812,"organizerId":852147,"type":"party","title":"Grande Latino Party","description":"Come to our grande latino party and enjoy dancing most popular latino dances! Two floors, salsa and sensual, are awaiting!","dances":["salsa","bachata","kizomba"],"address":"Svetog Save 60, Bijeljina 76300","coords":[44.756244,19.2117792],"start":"2023-09-26T21:00:00","end":"2023-09-27T03:00:00"},{"id":512479632,"organizerId":852147,"type":"party","title":"Grande Latino Party","description":"Come to our grande latino party and enjoy dancing most popular latino dances! Two floors, salsa and sensual, are awaiting!","dances":["salsa","bachata","kizomba"],"address":"Patrijarha Pavla 1, Bijeljina 76300","coords":[44.7568797,19.2174305],"start":"2023-11-15T21:00:00","end":"2023-11-16T03:00:00"},{"id":256789654,"organizerId":852147,"type":"party","title":"Sensual party","description":"Hola, sensual gente! Come join us on our sensual floor and dance bachata and kizomba!","dances":["bachata","kizomba"],"address":"Gavrila Principa, Bijeljina 76300","coords":[44.7562342,19.2139896],"start":"2023-10-19T21:00:00","end":"2023-10-20T03:00:00"},{"id":112489632,"organizerId":852147,"type":"festival","title":"\u0421\u0430\u043B\u0430\u0448 Salsa fest","description":"Did you ever want to try out native serbian cousine, dance to the sunset by the pool and enjoy the best coctails? Well, in that case, \u0421\u0430\u043B\u0430\u0448 Salsa Fest is just for you!","dances":["salsa","bachata","kizomba"],"address":"Pavlovi\u0107a put, Dvorovi 76300","coords":[44.7860709,19.2779482],"start":"2024-06-14T21:00:00","end":"2024-06-17T05:00:00"},{"id":220158962,"organizerId":852147,"type":"workshop","title":"Don Marko y su Salsa Familia Workshop","description":"Join us and learn from the best! Don Marko y su Salsa Familia are one of the best dance schools in Belgrade for the past 10 years!","dances":["salsa"],"address":"Srpske vojske 2, Bijeljina 76300","coords":[44.7543854,19.2171592],"start":"2023-12-12T12:00:00","end":"2023-12-12T14:00:00"},{"id":885792105,"organizerId":758962,"type":"workshop","title":"El grande tango","description":"We have an honor of bringing Tango world champions, Vedran and Valentina from Sarajevo, to Bijeljina for their amazing workshop!","dances":["tango"],"address":"Gradski park, Bijeljina 76300","coords":[44.7546408,19.2200756],"start":"2023-09-19T12:00:00","end":"2023-09-19T15:00:00"},{"id":962358956,"organizerId":748512,"type":"workshop","title":"Freedom is in elegance","description":"Ilya Gavrikov and Liza Semashko are world rumba champions! Seize this amazing opportunity to dance and learn rumba from the best!","dances":["rumba"],"address":"Njego\u0161eva 8, Bijeljina 76300","coords":[44.7596387,19.2187028],"start":"2023-11-22T14:00:00","end":"2023-11-22T16:00:00"},{"id":124555789,"organizerId":125967,"type":"workshop","title":"El fuego Brasiliero","description":"Ever wanted to learn samba from the world champions? Well, Riccardo Cocchi and Yulia Zagoruychenko are holding workshop in Bijeljina!","dances":["samba"],"address":"Sremska, Bijeljina 76300","coords":[44.7613323,19.2017821],"start":"2024-02-26T14:00:00","end":"2024-02-26T17:00:00"},{"id":221447963,"organizerId":125967,"type":"party","title":"Feel the energy","description":"Feel the pure energy of reggaeton while dancing with us on our party!","dances":["reggaeton"],"address":"Majora Dragutina Gavrilovi\u0107a 3, Bijeljina 76300","coords":[44.7571576,19.2121159],"start":"2024-01-04T21:00:00","end":"2024-01-05T03:00:00"},{"id":332665547,"organizerId":521747,"type":"workshop","title":"Zumba workshop","description":"Guess what, everyone? Rina Elena is coming to Bijeljina! Don\'t miss out on this great opportunity to learn a few moves from her!","dances":["zumba"],"address":"Sremska 4, Bijeljina 76300","coords":[44.7626719,19.2097289],"start":"2024-03-03T12:00:00","end":"2024-03-03T14:00:00"}],"danceStudios":[{"id":758962,"name":"101 dance club","address":"Ive Andri\u0107a, Bijeljina 76300","coords":[44.7613323,19.2017821],"type":["club","studio"],"danceTypes":["tango","reggaeton","rumba","zumba","samba"],"pageUrl":"https://www.facebook.com/plesniklub101/","phoneNumber":"065/111-222","description":"Vi\u0161e od tri decenije rada su garancija da cete sa nama nau\u010Diti sve vrste plesova.","workingTimes":[{"day":"Monday","startTime":"20:00:00","endTime":"21:00:00"},{"day":"Tuesday","startTime":"19:00:00","endTime":"20:00:00"},{"day":"Thursday","startTime":"20:00:00","endTime":"21:00:00"}]},{"id":125967,"name":"Megadance dance club","address":"Patrijarha Pavla 1, Bijeljina 76300","coords":[44.7568797,19.2174305],"type":["club","studio"],"danceTypes":["salsa","bachata","tango","reggaeton","rumba","zumba","samba"],"pageUrl":"https://www.facebook.com/MegadanceDanceStudio/","phoneNumber":"065/333-444","description":"MEGADANCE plesni studio nudi vam razli\u010Dite vrste plesova, profesionalnog (takmi\u010Darskog) i rekreativno-socijalnog.","workingTimes":[{"day":"Friday","startTime":"12:00:00","endTime":"22:00:00"},{"day":"Saturday","startTime":"12:00:00","endTime":"22:00:00"},{"day":"Sunday","startTime":"12:00:00","endTime":"22:00:00"}]},{"id":852147,"name":"El Ritmo Loco \u0161kola plesa","address":"Srpske Vojske 2, Bijeljina 76300","coords":[44.7543854,19.2171592],"type":["school","studio"],"danceTypes":["salsa","bachata","kizomba","reggaeton"],"pageUrl":"https://www.instagram.com/elritmolocosalsa/?hl=en","phoneNumber":"065/555-666","description":"Plesom do zvezda \uD83D\uDC83\uD83D\uDD7A\u2B50\u2B50\u2B50, ili makar do dobre zabave!","workingTimes":[{"day":"Tuesday","startTime":"19:00:00","endTime":"21:00:00"},{"day":"Thursday","startTime":"20:00:00","endTime":"21:00:00"},{"day":"Saturday","startTime":"16:00:00","endTime":"18:00:00"}]},{"id":521747,"name":"ZumFit dance studio","address":"Njegoseva bb, Bijeljina 76300","coords":[44.7596387,19.2187028],"type":["studio"],"danceTypes":["reggaeton","zumba"],"pageUrl":"https://www.facebook.com/profile.php?id=100052848158383","phoneNumber":"065/777-888","description":"ZUMBA je spoj latinskih i internacionalnih ritmova koji uz tematski ples stvaraju dinami\u010Dan, uzbudljiv i eksplozivan osjecaj.","workingTimes":[{"day":"Tuesday","startTime":"20:00:00","endTime":"21:00:00"},{"day":"Thursday","startTime":"20:00:00","endTime":"21:00:00"}]},{"id":748512,"name":"Olena dance studio","address":"Ive Andri\u0107a 56, Bijeljina 76300","coords":[44.7615958,19.20176],"type":["club","studio"],"danceTypes":["salsa","bachata","reggaeton","zumba","rumba"],"pageUrl":"","phoneNumber":"065/999-000","description":"Trust us, everyone can dance.","workingTimes":[{"day":"Wednesday","startTime":"20:00:00","endTime":"21:00:00"},{"day":"Sunday","startTime":"20:00:00","endTime":"21:00:00"}]}]}');


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    filtersSelected: {},
    filters: {},
    danceEvents: [],
    danceStudios: [],
    selectedId: ""
};
const $0f1d4402dffacf5b$var$init = function() {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.filtersSelected = (0, (/*@__PURE__*/$parcel$interopDefault($7e152637e430236b$exports))).filtersSelected;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.filters = (0, (/*@__PURE__*/$parcel$interopDefault($7e152637e430236b$exports))).filters;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.danceEvents = (0, (/*@__PURE__*/$parcel$interopDefault($7e152637e430236b$exports))).danceEvents;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.danceStudios = (0, (/*@__PURE__*/$parcel$interopDefault($7e152637e430236b$exports))).danceStudios;
};
const $0f1d4402dffacf5b$export$2cdef1529288ac75 = function() {
    const selectedTypes = Object.entries($0f1d4402dffacf5b$export$ca000e230c0caa3e.filtersSelected.types).filter(([_, isChecked])=>isChecked).map(([type])=>type);
    const selectedDances = Object.entries($0f1d4402dffacf5b$export$ca000e230c0caa3e.filtersSelected.dances).filter(([_, isChecked])=>isChecked).map(([type])=>type);
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.danceStudios.filter((s)=>s.type.some((type)=>selectedTypes.includes(type))).filter((s)=>s.danceTypes.some((dance)=>selectedDances.includes(dance)));
};
const $0f1d4402dffacf5b$export$1cd6dc79aef553b5 = function() {
    const selectedEventTypes = Object.entries($0f1d4402dffacf5b$export$ca000e230c0caa3e.filtersSelected.events).filter(([_, isChecked])=>isChecked).map(([eventType])=>eventType);
    const selectedDances = Object.entries($0f1d4402dffacf5b$export$ca000e230c0caa3e.filtersSelected.dances).filter(([_, isChecked])=>isChecked).map(([type])=>type);
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.danceEvents.filter((e)=>selectedEventTypes.includes(e.type)).filter((e)=>e.dances.some((dance)=>selectedDances.includes(dance)));
};
const $0f1d4402dffacf5b$export$4c8b7dade296602f = function(id) {
    return id.length === 6 ? $0f1d4402dffacf5b$export$ca000e230c0caa3e.danceStudios.find((el)=>el.id === +id) : $0f1d4402dffacf5b$export$ca000e230c0caa3e.danceEvents.find((el)=>el.id === +id);
};
$0f1d4402dffacf5b$var$init();


class $b2d7157267813d3a$export$2e2bcd8739ae039 {
    _data;
    render(data) {
        this._data = data;
        const markup = this._generateMarkup();
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    update(data) {
        this.render(data);
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
}


class $540ab14e92756e71$var$SliderStudiosView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".slide--studios");
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    addHandlerClick(handler) {
        this._parentElement.addEventListener("click", handler);
    }
    _generateMarkup() {
        if (this._data.length > 0) {
            let studiosHTML = "<h3><i>Schools/clubs/studios</i></h3>";
            this._data.forEach((ds)=>studiosHTML += this._generateStudio(ds));
            return studiosHTML;
        } else return "<h1>There are no selected studios, schools or clubs. Check the options you selected to filter out and try again.</h1>";
    }
    _generateStudio(ds) {
        let text = "";
        text += `<div class="slide__item" data-id="${ds.id}" data-slider="0"><h2>${ds.name}</h2>`;
        text += `Address: <h3>${ds.address}</h3>Types: `;
        ds.type.forEach((t)=>text += `<b>${t}</b>, `);
        text = text.split("").slice(0, text.length - 2).join("");
        text += "</div>";
        return text;
    }
    highlightElement(id) {
        document.querySelectorAll(".slide__item").forEach((el)=>{
            if (+el.dataset.id === +id) {
                const slider = document.querySelector(".slider");
                const sliderNumber = +el.dataset.slider;
                const targetPosition = el.getBoundingClientRect().top - slider.getBoundingClientRect().top;
                slider.scrollTop += targetPosition;
                el.classList.add("selected");
                return sliderNumber;
            }
        });
    }
    findClickedElement(e) {
        return e.target.closest(".slide__item");
    }
    clearElements() {
        const slideItems = Array.from(this._parentElement.childNodes);
        slideItems.forEach((item)=>item.classList.remove("selected"));
    }
}
var $540ab14e92756e71$export$2e2bcd8739ae039 = new $540ab14e92756e71$var$SliderStudiosView();




class $fb6706b651f4615d$var$SliderEventsView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".slide--events");
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    addHandlerClick(handler) {
        this._parentElement.addEventListener("click", handler);
    }
    _generateMarkup() {
        if (this._data.length > 0) {
            let eventsHTML = "<h3><i>Events</i></h3>";
            this._data.forEach((de)=>eventsHTML += this._generateEvent(de));
            return eventsHTML;
        } else return "<h1>There are no selected events. Check the options you selected to filter out and try again.</h1>";
    }
    _generateEvent(de) {
        let text = "";
        text += `<div class="slide__item" data-id="${de.id}" data-slider="1"><h2>${de.title}</h2>`;
        text += `Address: <h3>${de.address}</h3>`;
        text += `Organizer: <h3>${$0f1d4402dffacf5b$export$ca000e230c0caa3e.danceStudios.filter((s)=>s.id === de.organizerId)[0].name}</h3>Dances: <b>`;
        de.dances.forEach((d)=>text += `${d}, `);
        text = text.split("").slice(0, text.length - 2).join("");
        text += "</b></div>";
        return text;
    }
    highlightElement(id) {
        document.querySelectorAll(".slide__item").forEach((el)=>{
            if (+el.dataset.id === +id) {
                const slider = document.querySelector(".slider");
                const sliderNumber = +el.dataset.slider;
                const targetPosition = el.getBoundingClientRect().top - slider.getBoundingClientRect().top;
                slider.scrollTop += targetPosition;
                el.classList.add("selected");
                return sliderNumber;
            }
        });
    }
    findClickedElement(e) {
        return e.target.closest(".slide__item");
    }
    clearElements() {
        const slideItems = Array.from(this._parentElement.childNodes);
        slideItems.forEach((item)=>item.classList.remove("selected"));
    }
}
var $fb6706b651f4615d$export$2e2bcd8739ae039 = new $fb6706b651f4615d$var$SliderEventsView();


class $bcf5b9f62c105673$var$ModalView {
    modal = document.querySelector(".modal");
    overlay = document.querySelector(".overlay");
    addHandlerClick(handler) {
        document.querySelectorAll(".close-modal").forEach((el)=>el.addEventListener("click", handler));
    }
    addHandlerKeyDown(handler) {
        document.addEventListener("keydown", function(e) {
            if (e.code === "Escape") handler();
        });
    }
}
var $bcf5b9f62c105673$export$2e2bcd8739ae039 = new $bcf5b9f62c105673$var$ModalView();



const $ba30e20475feac5a$export$d38288df22ff1bbe = 17;
const $ba30e20475feac5a$export$b20b1de127f812e2 = 1000;


class $716941e1f0265cb4$var$MapView {
    _parentElement = document.querySelector(".description__content");
    _mapMarkers = [];
    map;
    addHandlerLoad(handler) {
        window.addEventListener("load", handler);
    }
    constructor(){
        this.map = L.map("map").setView([
            44.757461,
            19.212
        ], 16);
        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
    }
    _generateEventMarker(e) {
        return `<div class="dance-event--${e.type}" data-id="${e.id}" >
    <div style="text-align: center;"><h3 class="event-marker--title">${e.title}</h3></div>
    <hr>
      <div class="event-marker--organiser">Organized by: <b>${$0f1d4402dffacf5b$export$ca000e230c0caa3e.danceStudios.find((ds)=>ds.id === e.organizerId).name}</b></div><hr>
      <div class="event-marker--type" style="text-align: center;"><b>${e.type}</b></div><hr>
      <div class="event-marker--time"><b>${new Intl.DateTimeFormat("sr-SR").format(new Date(e.start.split("T")[0]))} ${e.start.split("T")[1].slice(0, -3)} - ${new Intl.DateTimeFormat("sr-SR").format(new Date(e.end.split("T")[0]))} ${e.end.split("T")[1].slice(0, -3)}</b></div><hr>
        <div class="event-marker--dances">Dances: <b>${e.dances.reduce((cur, acc)=>acc + ", " + cur)}</b></div>
        </div>`;
    }
    _generateStudioMarker(s) {
        return `<div class="dance-studio" data-id="${s.id}"><div class="studio-marker--name" style="text-align: center;"><h3>${s.name}</h3></div>
    <hr><div class="studio-marker--type"><b>Dance ${s.type.reduce((cur, acc)=>acc + ", dance " + cur)}</b></div><div class="studio-marker--address">
      <hr><b>${s.address}</b><hr></div>`;
    }
    loadStudiosToMap(studios) {
        this._mapMarkers = [];
        studios.forEach((ds)=>{
            const marker = L.marker(ds.coords, {
                maxWidth: 500,
                minWidth: 100,
                riseOnHover: true,
                title: ds.name
            }).addTo(this.map).bindPopup(this._generateStudioMarker(ds));
            this._mapMarkers.push(marker);
        });
        return this._mapMarkers;
    }
    loadEventsToMap(events) {
        this._mapMarkers = [];
        let customIcon = L.icon({
            iconUrl: "/placeholder.png",
            iconSize: [
                35,
                35
            ],
            popupAnchor: [
                0,
                -15
            ]
        });
        events.forEach((de)=>{
            const marker = L.marker(de.coords, {
                icon: customIcon,
                maxWidth: 600,
                minWidth: 100,
                riseOnHover: true,
                title: de.title
            }).addTo(this.map).bindPopup(this._generateEventMarker(de));
            this._mapMarkers.push(marker);
        });
        return this._mapMarkers;
    }
    clearAllMarkersFromMap(mapMarkers) {
        if (mapMarkers.length > 0) mapMarkers.forEach((marker)=>{
            this.map.removeLayer(marker);
        });
    }
    goToMarker(coords) {
        this.map.setView(coords, (0, $ba30e20475feac5a$export$d38288df22ff1bbe), {
            animate: true,
            pan: {
                duration: 1
            }
        });
    }
    openPopup(mapMarkers, requiredId, type) {
        setTimeout(function() {
            mapMarkers.forEach((marker)=>{
                const markerId = +marker.getPopup().getContent().split(" ")[2].split('"')[1];
                if (markerId === +requiredId) marker.openPopup();
            });
        }, type === "marker" ? 10 : (0, $ba30e20475feac5a$export$b20b1de127f812e2));
    }
    closeAllMarkers() {
        this._mapMarkers.forEach((marker)=>marker.closePopup());
    }
}
var $716941e1f0265cb4$export$2e2bcd8739ae039 = new $716941e1f0265cb4$var$MapView();



const $bd02c871d9c5ba8e$export$3861f50527090e00 = function(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};


class $46e8c842b7c8a630$var$FiltersView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".form-container");
    _applyFiltersButton = document.querySelector(".btn--filter-apply");
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    addHandlerClickApply(handler) {
        this._applyFiltersButton.addEventListener("click", handler);
    }
    _generateMarkup() {
        let markup = '<div class="form-container--studios">';
        markup += this._loadFilterParts("types");
        markup += '</div><div class="form-container--type-of-events">';
        markup += this._loadFilterParts("events");
        markup += '</div><div class="form-container--dances">';
        markup += this._loadFilterParts("dances") + "</div>";
        return markup;
    }
    updateFilters(filters) {
        const checkboxes = [
            ...document.querySelectorAll('.form-control input[type="checkbox"]')
        ];
        checkboxes.forEach((checkbox)=>{
            const id = checkbox.id;
            const checked = checkbox.checked;
            if (id in filters.events) filters.events[id] = checked;
            if (id in filters.types) filters.types[id] = checked;
            if (id in filters.dances) filters.dances[id] = checked;
        });
    }
    _loadFilterParts(type) {
        let markup = "";
        switch(type){
            case "types":
                markup += `<label class="form__label">Schools/clubs/studios</label>`;
                break;
            case "events":
                markup += `<label class="form__label">Events</label>`;
                break;
            case "dances":
                markup += `<label class="form__label">Preffered dances</label>`;
                break;
        }
        [
            ...this._data[type]
        ].forEach((el)=>markup += `
					<div class="form-control">
						<input id="${el}" type="checkbox" checked />
						<label>${type === "types" ? "Dance " + el + "s" : (0, $bd02c871d9c5ba8e$export$3861f50527090e00)(el)}</label>
					</div>
				`);
        return markup;
    }
}
var $46e8c842b7c8a630$export$2e2bcd8739ae039 = new $46e8c842b7c8a630$var$FiltersView();



class $60a27a0470c9a625$var$SliderView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _curSlide = 0;
    _parentElement = document.querySelector(".slider");
    _slides = document.querySelectorAll(".slide");
    _currentlyActiveSlideOfSlider = "slide--studios";
    _maxSlide = this._slides.length;
    addHandlerWheel(handler) {
        this._parentElement.addEventListener("wheel", function(e) {
            handler(e);
        });
    }
    constructor(){
        super();
        this._slides.forEach((s, i)=>s.style.transform = `translateX(${i * 100}%)`);
    }
    goToSlide(slide) {
        this._curSlide = slide;
        this._currentlyActiveSlideOfSlider = slide === 1 ? "slide--events" : "slide--studios";
        this._slides.forEach((s, i)=>s.style.transform = `translateX(${100 * (i - slide)}%)`);
    }
    changeSlide(dir) {
        this._curSlide = dir === "left" ? this._curSlide === 0 ? this._maxSlide - 1 : this._curSlide - 1 : this._curSlide === this._maxSlide - 1 ? 0 : this._curSlide + 1;
        this._slides.scrollTop = 0;
        this.goToSlide(this._curSlide);
    }
    scrollToPosition(position, slide) {
        this._parentElement.scrollTop += position;
        this.goToSlide(slide);
    }
    stopsTheWheel(e) {
        if (e.deltaY > 0) {
            const topCoord = [].slice.call(document.querySelector(`.${this._currentlyActiveSlideOfSlider}`).children).slice(-1)[0].getBoundingClientRect().top;
            if (topCoord <= this._parentElement.getBoundingClientRect().top) e.preventDefault();
        }
    }
    scrollToTheTop() {
        this._parentElement.scrollTop = 0;
    }
}
var $60a27a0470c9a625$export$2e2bcd8739ae039 = new $60a27a0470c9a625$var$SliderView();


class $3a02bb24bb570555$var$SliderArrowsView {
    _curSlide = 0;
    _slides = document.querySelectorAll(".slide");
    _leftArrow = document.querySelector(".slider__arrow--left");
    _rightArrow = document.querySelector(".slider__arrow--right");
    _maxSlide = this._slides.length;
    addHandlerArrowClick(handler, direction) {
        if (direction === "left") this._leftArrow.addEventListener("click", function() {
            handler("left");
        });
        else this._rightArrow.addEventListener("click", function() {
            handler("right");
        });
    }
}
var $3a02bb24bb570555$export$2e2bcd8739ae039 = new $3a02bb24bb570555$var$SliderArrowsView();


class $862b8a90f7d689c5$var$LocationContainerView {
    _curContainer = 0;
    _locationContainer = document.querySelector(".locations__container");
    _containers = document.querySelectorAll(".container");
    _toggleDisplayDescriptionButton = document.querySelector(".btn--description-control");
    addHandlerClick(handler) {
        this._toggleDisplayDescriptionButton.addEventListener("click", handler);
    }
    constructor(){
        this._containers.forEach((c, i)=>c.style.transform = `translateY(${i * 90}%)`);
    }
    goToContainer(cont) {
        this._curContainer = cont;
        this._containers.forEach((s, i)=>s.style.transform = `translateY(${90 * (i - cont)}%)`);
    }
    toggleDescriptionButton() {
        this._toggleDisplayDescriptionButton.innerHTML = this._toggleDisplayDescriptionButton.innerHTML.trim() === "Display details" ? "Hide details" : "Display details";
    }
    toggleIfButtonIsDisabled(enable) {
        if (enable) {
            this._toggleDisplayDescriptionButton.setAttribute("disabled", "");
            this._toggleDisplayDescriptionButton.innerHTML = "Display details";
        } else this._toggleDisplayDescriptionButton.removeAttribute("disabled");
    }
}
var $862b8a90f7d689c5$export$2e2bcd8739ae039 = new $862b8a90f7d689c5$var$LocationContainerView();



class $ea9152ebdcdab405$var$SidebarView {
    _curSlideOfSidebar = 0;
    _curSliderPosition = -1;
    _rootElement = document.querySelector(".sidebar");
    _sidebarRows = document.querySelectorAll(".sidebar__row");
    _toggleFiltersButton = document.querySelector(".btn--toggle-filters");
    _toggleButton = document.querySelector(".show-hide-btn");
    _showHideArrows = Array.from(document.querySelectorAll(".show-hide-arrow"));
    constructor(){
        this._sidebarRows.forEach((s, i)=>s.style.transform = `translateY(${i * 100}%)`);
        this._sidebarRows[1].classList.toggle("hidden");
    }
    addHandlerToggleFilters(handler) {
        this._toggleFiltersButton.addEventListener("click", handler);
    }
    addHandlerToggleSidebar(handler) {
        this._toggleButton.addEventListener("click", handler);
    }
    toggleSidebar() {
        this._curSliderPosition = this._curSliderPosition === -1 ? 0 : -1;
        this._rootElement.style.transform = `translateX(${this._curSliderPosition * 100}%)`;
        this._toggleButton.style.transform = `translateX(${(this._curSliderPosition + 1) * this._rootElement.clientWidth}px)`;
        this._showHideArrows.forEach((a)=>a.classList.toggle("excluded"));
    }
    toggleSlider() {
        const prevSlide = this._curSlideOfSidebar;
        this._curSlideOfSidebar = this._curSlideOfSidebar === 0 ? 1 : 0;
        this._sidebarRows[this._curSlideOfSidebar].classList.remove("hidden");
        this._sidebarRows.forEach((s, i)=>s.style.transform = `translateY(${100 * (i - this._curSlideOfSidebar)}%)`);
        setTimeout(()=>{
            this._sidebarRows[prevSlide].classList.add("hidden");
        }, (0, $ba30e20475feac5a$export$b20b1de127f812e2));
    }
}
var $ea9152ebdcdab405$export$2e2bcd8739ae039 = new $ea9152ebdcdab405$var$SidebarView();



class $c34a89588b91ccbd$var$DetailsView extends (0, $b2d7157267813d3a$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".description__content");
    _generateMarkup() {
        // console.log(this._data);
        let markup = "";
        if ((this._data.id + "").length === 6) {
            // STUDIO
            markup += `<h1 class='content--studio-name'>${this._data.name}</h1>`;
            markup += `<div class='content--studio-description'><span class='studio-description'>"${this._data.description}"</span></div>`;
            if (this._data.type.length > 1) {
                markup += `<div class='content--studio-types'><ul>Types:`;
                this._data.type.forEach((type)=>markup += `<li class='content--studio-type-item'>${type}</li>`);
                markup += `</ul></div>`;
            } else markup += `<div class='content--studio-type'>Type: <span class='studio-type'>${this._data.type[0]}</span></div>`;
            if (this._data.danceTypes.length > 1) {
                markup += `<div class='content--studio-dance-types'><ul>Dances:`;
                this._data.danceTypes.forEach((danceType)=>markup += `<li class='content--studio-dance-type-item'>${danceType}</li>`);
                markup += `</ul></div>`;
            } else markup += `<div class='content--studio-dance-type'>Dance: <span class='studio-dance-type'>${this._data.danceTypes[0]}</span></div>`;
            markup += `<div class='content--studio-address'>Address: <span class='studio-address'>${this._data.address}</span></div>`;
            if (this._data.pageUrl !== "") markup += `<div class='content--studio-page'>Page URL: <a href='${this._data.pageUrl}' target='_blank' class='studio-page'>${this._data.name}</a></div>`;
            else markup += `<div class='content--studio-page'>Page URL: <span class='studio-page'>They apparently have no page :(</span></div>`;
            markup += `<div class='content--studio-phone'>Phone number: <span class='studio-phone'>${this._data.phoneNumber}</span></div>`;
            if (this._data.workingTimes.length > 1) {
                markup += `<div class='content--studio-working-times'><ul>Working times:`;
                this._data.workingTimes.forEach((wt)=>markup += `<li class='content--studio-working-time-item'>${wt.day}: ${wt.startTime.substring(0, 5)} - ${wt.endTime.substring(0, 5)}</li>`);
                markup += `</ul></div>`;
            } else markup += `<div class='content--studio-working-time'>Workingtime: <span class='studio-working-time'>${this._data.workingTimes[0].day}: ${this._data.workingTimes[0].startTime.substring(0, 5)} - ${this._data.workingTimes[0].endTime.substring(0, 5)}</span></div>`;
        } else {
            //EVENT
            markup += `<h1 class='content--dance-event-title'>${this._data.title}</h1>`;
            markup += `<div class='content--dance-event-description'><span class='dance-event-description'>${this._data.description}</span></div>`;
            markup += `<div class='content--dance-event-type'>Type of event: <span class='dance-event-type'>${this._data.type}</span></div>`;
            if (this._data.dances.length > 1) {
                markup += `<div class='content--dance-event-dances'><ul>Dances included:`;
                this._data.dances.forEach((dance)=>markup += `<li class='dance--event-dance-item'>${dance}</li>`);
                markup += `</ul></div>`;
            } else markup += `<div class='content--dance-event-dance'>Dance: <span class='dance-event-dance'>${this._data.dances[0]}</span></div>`;
            markup += `<div class='content--dance-event-address'>Address: <span class='dance-event-address'>${this._data.address}</span></div>`;
            const startDateAndTimeSplit = this._data.start.split("T");
            const startDateAndTime = `${startDateAndTimeSplit[0].split("-").reverse().join(".")} - ${startDateAndTimeSplit[1].substring(0, 5)}`;
            const endDateAndTimeSplit = this._data.end.split("T");
            const endDateAndTime = `${endDateAndTimeSplit[0].split("-").reverse().join(".")} - ${endDateAndTimeSplit[1].substring(0, 5)}`;
            markup += `<div class='content--dance-event-start-time'>Start time: <span class='dance-event-start-time'>${startDateAndTime}</span></div> `;
            markup += `<div class='content--dance-event-end-time'>End time: <span class='dance-event-end-time'>${endDateAndTime}</span></div> `;
        }
        return markup;
    }
}
var $c34a89588b91ccbd$export$2e2bcd8739ae039 = new $c34a89588b91ccbd$var$DetailsView();


let $f50bd1f2915ed0f2$var$mapMarkers = [];
const $f50bd1f2915ed0f2$var$controlSliderStudiosView = function() {
    // Generate list of studios
    (0, $540ab14e92756e71$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.danceStudios);
};
const $f50bd1f2915ed0f2$var$controlSliderEventsView = function() {
    // Generate list of studios
    (0, $fb6706b651f4615d$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.danceEvents);
};
const $f50bd1f2915ed0f2$var$controlModalView = function() {
    // Hides modal elements
    (0, $bcf5b9f62c105673$export$2e2bcd8739ae039).modal.classList.add("hidden");
    (0, $bcf5b9f62c105673$export$2e2bcd8739ae039).overlay.classList.add("hidden");
};
const $f50bd1f2915ed0f2$var$controlMapView = function() {
    // loading initial data
    $f50bd1f2915ed0f2$var$mapMarkers = $f50bd1f2915ed0f2$var$mapMarkers.concat([
        ...(0, $716941e1f0265cb4$export$2e2bcd8739ae039).loadEventsToMap($0f1d4402dffacf5b$export$ca000e230c0caa3e.danceEvents)
    ]);
    $f50bd1f2915ed0f2$var$mapMarkers = $f50bd1f2915ed0f2$var$mapMarkers.concat([
        ...(0, $716941e1f0265cb4$export$2e2bcd8739ae039).loadStudiosToMap($0f1d4402dffacf5b$export$ca000e230c0caa3e.danceStudios)
    ]);
    // adding click event to the markers
    $f50bd1f2915ed0f2$var$addClickEventToMapMarkers();
    // adding map click event
    (0, $716941e1f0265cb4$export$2e2bcd8739ae039).map.on("click", function() {
        $f50bd1f2915ed0f2$var$clearAllListElements();
        (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).toggleIfButtonIsDisabled(true);
        $f50bd1f2915ed0f2$var$closeDescriptionButton();
    });
};
const $f50bd1f2915ed0f2$var$controlFiltersView = function() {
    (0, $46e8c842b7c8a630$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.filters);
};
const $f50bd1f2915ed0f2$var$controlSliderView = function(e) {
    // add "stopping the wheel" event
    (0, $60a27a0470c9a625$export$2e2bcd8739ae039).stopsTheWheel(e);
};
const $f50bd1f2915ed0f2$var$controlToggleSidebar = function() {
    (0, $ea9152ebdcdab405$export$2e2bcd8739ae039).toggleSidebar();
};
const $f50bd1f2915ed0f2$var$controlSliderArrowsView = function(dir) {
    (0, $60a27a0470c9a625$export$2e2bcd8739ae039).scrollToTheTop();
    (0, $60a27a0470c9a625$export$2e2bcd8739ae039).changeSlide(dir);
};
const $f50bd1f2915ed0f2$var$controlApplyFilters = function() {
    // toggle filters slider
    (0, $ea9152ebdcdab405$export$2e2bcd8739ae039).toggleSlider();
    //clear all markers from map
    (0, $716941e1f0265cb4$export$2e2bcd8739ae039).clearAllMarkersFromMap($f50bd1f2915ed0f2$var$mapMarkers);
    //update filters
    (0, $46e8c842b7c8a630$export$2e2bcd8739ae039).updateFilters($0f1d4402dffacf5b$export$ca000e230c0caa3e.filtersSelected);
    //get updated studios and events
    const studiosForDisplay = $0f1d4402dffacf5b$export$2cdef1529288ac75();
    const eventsForDisplay = $0f1d4402dffacf5b$export$1cd6dc79aef553b5();
    //update studios and events
    (0, $540ab14e92756e71$export$2e2bcd8739ae039).update(studiosForDisplay);
    (0, $fb6706b651f4615d$export$2e2bcd8739ae039).update(eventsForDisplay);
    //render updated studios and events to map
    $f50bd1f2915ed0f2$var$mapMarkers = [];
    $f50bd1f2915ed0f2$var$mapMarkers = $f50bd1f2915ed0f2$var$mapMarkers.concat((0, $716941e1f0265cb4$export$2e2bcd8739ae039).loadStudiosToMap(studiosForDisplay));
    $f50bd1f2915ed0f2$var$mapMarkers = $f50bd1f2915ed0f2$var$mapMarkers.concat((0, $716941e1f0265cb4$export$2e2bcd8739ae039).loadEventsToMap(eventsForDisplay));
    //add click events to the markers
    $f50bd1f2915ed0f2$var$addClickEventToMapMarkers();
    //scroll to the top
    (0, $60a27a0470c9a625$export$2e2bcd8739ae039).scrollToTheTop();
};
const $f50bd1f2915ed0f2$var$controlSidebarViewToggleFilters = function() {
    setTimeout(function() {
        (0, $ea9152ebdcdab405$export$2e2bcd8739ae039).toggleSlider();
    }, 10);
};
const $f50bd1f2915ed0f2$var$controlSliderEventsViewClick = function(e) {
    // finding clicked element (sliderEventsView)
    const el = (0, $fb6706b651f4615d$export$2e2bcd8739ae039).findClickedElement(e);
    // finding selected event (model)
    if (!el) return;
    const selectedElement = $0f1d4402dffacf5b$export$4c8b7dade296602f(el.dataset.id);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectedId = el.dataset.id;
    // move to selected marker on the map (mapView)
    (0, $716941e1f0265cb4$export$2e2bcd8739ae039).goToMarker(selectedElement.coords);
    // memorizing selected element id ???
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectedId = el.dataset.id;
    // clear previous highlighted element
    $f50bd1f2915ed0f2$var$clearAllListElements();
    (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).toggleIfButtonIsDisabled(true);
    $f50bd1f2915ed0f2$var$closeDescriptionButton();
    // highlighting element (sliderEventsView)
    $f50bd1f2915ed0f2$var$highlightListElement(el.dataset.id);
};
const $f50bd1f2915ed0f2$var$controlSliderStudiosViewClick = function(e) {
    // finding clicked element (sliderEventsView)
    const el = (0, $540ab14e92756e71$export$2e2bcd8739ae039).findClickedElement(e);
    // finding selected event (model)
    if (!el) return;
    const selectedElement = $0f1d4402dffacf5b$export$4c8b7dade296602f(el.dataset.id);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectedId = el.dataset.id;
    // move to selected marker on the map (mapView)
    (0, $716941e1f0265cb4$export$2e2bcd8739ae039).goToMarker(selectedElement.coords);
    // memorizing selected element id ???
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectedId = el.dataset.id;
    // clear previous highlighted element
    $f50bd1f2915ed0f2$var$clearAllListElements();
    (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).toggleIfButtonIsDisabled(true);
    $f50bd1f2915ed0f2$var$closeDescriptionButton();
    // highlighting element (sliderEventsView)
    $f50bd1f2915ed0f2$var$highlightListElement(el.dataset.id);
};
const $f50bd1f2915ed0f2$var$closeDescriptionButton = function() {
    const descriptionContent = document.querySelector(".description__content");
    // hides details data
    (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).goToContainer(0);
    setTimeout(()=>{
        descriptionContent.classList.add("hidden");
    }, 1000);
};
const $f50bd1f2915ed0f2$var$controlDescriptionViewClick = function() {
    const descriptionContent = document.querySelector(".description__content");
    if (descriptionContent.classList.contains("hidden")) {
        // load details
        const id = +$0f1d4402dffacf5b$export$ca000e230c0caa3e.selectedId;
        const data = (id + "").length === 6 ? $0f1d4402dffacf5b$export$ca000e230c0caa3e.danceStudios.find((ds)=>ds.id === id) : $0f1d4402dffacf5b$export$ca000e230c0caa3e.danceEvents.find((ds)=>ds.id === id);
        (0, $c34a89588b91ccbd$export$2e2bcd8739ae039).render(data);
        // display details data
        (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).goToContainer(1);
        (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).toggleDescriptionButton();
        descriptionContent.classList.remove("hidden");
    } else {
        // hides details data
        (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).goToContainer(0);
        (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).toggleDescriptionButton();
        setTimeout(()=>{
            descriptionContent.classList.add("hidden");
        }, 1000);
    }
};
const $f50bd1f2915ed0f2$var$highlightListElement = function(id, type = "slider") {
    (0, $716941e1f0265cb4$export$2e2bcd8739ae039).openPopup($f50bd1f2915ed0f2$var$mapMarkers, id, type);
    document.querySelectorAll(".slide__item").forEach((el)=>{
        if (+el.dataset.id === +id) {
            const sliderNumber = +el.dataset.slider;
            const targetPosition = el.getBoundingClientRect().top - document.querySelector(".slider").getBoundingClientRect().top;
            (0, $60a27a0470c9a625$export$2e2bcd8739ae039).scrollToPosition(targetPosition, sliderNumber);
            el.classList.add("selected");
            (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).toggleIfButtonIsDisabled(false);
        }
    });
};
const $f50bd1f2915ed0f2$var$clearAllListElements = function() {
    (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).goToContainer(0);
    (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).toggleIfButtonIsDisabled(false);
    (0, $540ab14e92756e71$export$2e2bcd8739ae039).clearElements();
    (0, $fb6706b651f4615d$export$2e2bcd8739ae039).clearElements();
    (0, $716941e1f0265cb4$export$2e2bcd8739ae039).closeAllMarkers();
};
const $f50bd1f2915ed0f2$var$addClickEventToMapMarkers = function() {
    $f50bd1f2915ed0f2$var$mapMarkers.forEach((marker)=>marker.on("click", function() {
            const id = +marker.getPopup().getContent().split('data-id="')[1].split('"')[0];
            $f50bd1f2915ed0f2$var$clearAllListElements();
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.selectedId = id;
            $f50bd1f2915ed0f2$var$highlightListElement(id, "marker");
        }));
};
const $f50bd1f2915ed0f2$var$init = function() {
    window.addEventListener("scroll", ()=>{
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        document.querySelector(".sidebar__row--slider").style.top = `${scrollTop}px`;
        document.querySelector(".sidebar__row--filter").style.top = `${scrollTop}px`;
    });
    (0, $716941e1f0265cb4$export$2e2bcd8739ae039).addHandlerLoad($f50bd1f2915ed0f2$var$controlMapView);
    (0, $540ab14e92756e71$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlSliderStudiosView);
    (0, $fb6706b651f4615d$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlSliderEventsView);
    (0, $bcf5b9f62c105673$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlModalView);
    (0, $bcf5b9f62c105673$export$2e2bcd8739ae039).addHandlerKeyDown($f50bd1f2915ed0f2$var$controlModalView);
    (0, $46e8c842b7c8a630$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlFiltersView);
    (0, $60a27a0470c9a625$export$2e2bcd8739ae039).addHandlerWheel($f50bd1f2915ed0f2$var$controlSliderView);
    (0, $3a02bb24bb570555$export$2e2bcd8739ae039).addHandlerArrowClick($f50bd1f2915ed0f2$var$controlSliderArrowsView, "left");
    (0, $3a02bb24bb570555$export$2e2bcd8739ae039).addHandlerArrowClick($f50bd1f2915ed0f2$var$controlSliderArrowsView, "right");
    (0, $ea9152ebdcdab405$export$2e2bcd8739ae039).addHandlerToggleFilters($f50bd1f2915ed0f2$var$controlSidebarViewToggleFilters);
    (0, $ea9152ebdcdab405$export$2e2bcd8739ae039).addHandlerToggleSidebar($f50bd1f2915ed0f2$var$controlToggleSidebar);
    (0, $46e8c842b7c8a630$export$2e2bcd8739ae039).addHandlerClickApply($f50bd1f2915ed0f2$var$controlApplyFilters);
    (0, $fb6706b651f4615d$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlSliderEventsViewClick);
    (0, $540ab14e92756e71$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlSliderStudiosViewClick);
    (0, $862b8a90f7d689c5$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlDescriptionViewClick);
};
const $f50bd1f2915ed0f2$var$setAdvice = async function() {
    document.querySelector(".modal p").innerHTML = (await (await fetch("https://api.adviceslip.com/advice")).json()).slip.advice;
};
$f50bd1f2915ed0f2$var$init();
$f50bd1f2915ed0f2$var$setAdvice();


//# sourceMappingURL=index.e995b534.js.map
